import type React from 'react';

interface WordIconProps {
	width?: number;
	height?: number;
}

const WordIcon: React.FC<WordIconProps> = ({ width = 44, height = 45 }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 44 45"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Word document icon"
		>
			<path
				d="M34.344 0.112793L43.0958 9.23583V43.9285H10.4023V44.0418H43.2075V9.35065L34.344 0.112793Z"
				fill="#909090"
			/>
			<path
				d="M34.2378 0H10.293V43.929H43.0981V9.23786L34.2378 0Z"
				fill="#F4F4F4"
			/>
			<path
				d="M10.0511 2.35938H0V13.0978H31.616V2.35938H10.0511Z"
				fill="#7A7B7C"
			/>
			<path
				d="M31.783 12.9153H0.203125V2.16895H31.783V12.9153Z"
				fill="#2B579A"
			/>
			<path
				d="M7 6L8.5 14H10.5L12 8L13.5 14H15.5L17 6H15L14 12L12.5 6H11.5L10 12L9 6H7Z"
				fill="white"
			/>
			<path d="M19 18H38V20H19V18Z" fill="#2B579A" />
			<path d="M19 22H38V24H19V22Z" fill="#6FA8DC" />
			<path d="M19 26H38V28H19V26Z" fill="#2B579A" />
			<path d="M19 30H35V32H19V30Z" fill="#6FA8DC" />
			<path d="M19 34H33V36H19V34Z" fill="#2B579A" />
			<path
				d="M34.1172 0.121582V9.35944H42.9775L34.1172 0.121582Z"
				fill="#909090"
			/>
			<path d="M34.2344 0V9.23786H43.0947L34.2344 0Z" fill="#F4F4F4" />
		</svg>
	);
};

export default WordIcon;
